module.exports = __webpack_public_path__ + "static/phone-1a-ea6a67b67512b41fd18828fe9ae187cf.svg";